export const getDisplayUrl = (endpoint: string): string => {
  return endpoint.replace(/^https?:\/\//, '').replace(/[/?#].*$/, '');
};
